import { render, staticRenderFns } from "./ViParentHome.vue?vue&type=template&id=3d18cb76&scoped=true"
import script from "./ViParentHome.vue?vue&type=script&lang=js"
export * from "./ViParentHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18cb76",
  null
  
)

export default component.exports